import ldots from './css/ldots.gif';
import helpers from "./containers/helpers";

const WEBSITE_URL = 'https://vashcenter.gr';
const CONTACT_TEL = '+30 210 524 3933';

const lang = {
  ru: {
    contact: {
      legend: 'Контактные данные',
      elem: {
        firstname: {
          label: 'Имя',
          placeholder: 'Введите Ваше Имя'
        },
        lastname: {
          label: 'Фамилия',
          placeholder: 'Введите Вашу Фамилию'
        },
        phone: {
          label: 'Телефон',
          placeholder: 'Введите Ваш Телефон'
        },
        email: {
          label: 'E-mail',
          placeholder: 'Введите Ваш E-mail'
        }
      }
    },
    service: {
      legend: 'Услуги',
      labelOpt: 'Выберите услугу',
      labelDocs: 'Выберите документы',
      labelDocsInfoField: {
        empty: 'Выбрать...',
        selectedZero: 'Выберите заново...',
        selectedOne: '1 файл, Размер: $1',
        selectedMulti: 'Файлов: $1, Размер: $2'
      },
      labelDeadline: 'Укажите крайний срок',
      labelDescr: 'Описание',
      addOrderBtn: 'Добавить заказ',
      elem: {
        translation: {
          label: 'Перевод',
          labelDocs: ' для перевода',
          labelDetail: 'Направление перевода',
          description: 'Официальные переводы, письменные переводы, переводы Министерства иностранных дел Греции',
          language: [['translateFrom', 'Перевести с...'],
            ['translateTo', 'Перевести на...'], ['ru', 'Русский'],
            ['uk', 'Украинский'], ['el', 'Греческий'], ['en', 'Английский'],
            ['de', 'Немецкий'], ['fr', 'Французский'], ['it', 'Итальянский'],
            ['pt', 'Португальский'], ['az', 'Азербайджанский'],
            ['ar', 'Арабский'], ['am', 'Армянский'], ['be', 'Белорусский'],
            ['bg', 'Болгарский'], ['hu', 'Венгерский'], ['vi', 'Вьетнамский'],
            ['nl', 'Голландский (Нидерландский)'], ['ka', 'Грузинский'],
            ['da', 'Датский'], ['he', 'Иврит'], ['id', 'Индонезийский'],
            ['kk', 'Казахский'], ['ky', 'Киргизский'], ['zh', 'Китайский'],
            ['ko', 'Корейский'], ['la', 'Латинский'], ['lv', 'Латышский'],
            ['lt', 'Литовский'], ['mo', 'Молдавский'], ['no', 'Норвежский'],
            ['fa', 'Персидский'], ['pl', 'Польский'], ['ro', 'Румынский'],
            ['sr', 'Сербский'], ['sk', 'Словацкий'], ['sl', 'Словенский'],
            ['dr', 'Дари'], ['tg', 'Таджикский'], ['th', 'Тайский'],
            ['tt', 'Татарский'], ['tr', 'Турецкий'], ['tk', 'Туркменский'],
            ['uz', 'Узбекский'], ['fi', 'Финский'], ['hr', 'Хорватский'],
            ['cs', 'Чешский'], ['sv', 'Шведский'], ['hi', 'Хинди'],
            ['et', 'Эстонский'], ['ja', 'Японский']],
          state: ['translateFrom', 'translateTo'],
          details: {root: 'Перевод', translation: 'Перевод с $1 на $2'}
        },
        passport: {
          label: 'Паспорт',
          labelDocs: ': Загранпаспорт, ИНН, ВНЖ (адия)',
          description: 'Компания VashCenter оказывает помощь при оформлении пакета документов на продление или новый паспорт. Все вопросы продления срока действия паспортов, и помощь в изготовлении новых',
          details: {root: 'Загранпаспорт гражданина Украины'}
        },
        civil_reg: {
          label: 'ЗАГС',
          labelDocs: ': Загранпаспорт',
          labelSelect: 'Выбрать...',
          labelSelected: 'выбрано',
          labelSelectedAll: 'Выбрано все',
          description: 'Компания помогает с вопросами семейного права, оформлением пакета документов для брака, воссоединение семьи, а также помогает с оформлением справок таких как: Справка о смерти, Справка о рождении, Справка для оформления брака, Справка о разводе, Справка о смене Ф.И.О., Справка о семейном положении',
          certsLabel: 'Выберите требуемые справки',
          details: {root: 'ЗАГС'},
          certs: [
            {
              value: 'birth',
              label: 'Свидетельство о рождении',
              docs: 'Свидетельство о рождении'
            },
            {
              value: 'marriage',
              label: 'Справка для оформления брака',
              docs: 'VISA / ВНЖ, Свидетельство о рождении',
              details: 'Справка для оформления брака, страна: $1',
              state: ['marriage']
            },
            {
              value: 'divorce',
              label: 'Свидетельство о разводе',
              docs: 'VISA / ВНЖ, Свидетельство о разводе'
            },
            {
              value: 'fullname',
              label: 'Свидетельство о смене Ф.И.О.',
              docs: 'Свидетельство о рождении'
            },
            {
              value: 'family',
              label: 'Свидетельство о семейном положении'
            },
            {
              value: 'death',
              label: 'Свидетельство о смерти',
            }

          ],
          marriageLabel: 'Выберите страну брака',
          marriage: [['select', 'Выбрать...'], ['ru', 'Россия'],
            ['uk', 'Украина'], ['md', 'Молдова'], ['by', 'Беларусь'],
            ['ge', 'Грузия'], ['uz', 'Узбекистан'], ['kz', 'Казахстан'],
            ['tj', 'Таджикистан']],
        },
        residence: {
          label: 'ВНЖ',
          labelDocs: ': Загранпаспорт, ВНЖ',
          description: 'Подача и обновление вида на жительство всех категорий, подача на ВНЖ и гражданство согласно нового закона 4251/2014',
          details: {root: 'Вид на жительство'}
        },
        education: {
          label: 'Образование',
          labelDocs: ': Загранпаспорт, Атестат (школа)',
          description: 'Подготовка и оформление пакета документов для поступления в греческие ВУЗы',
          details: {root: 'Образование в Греции'}
        },
        min_justice_interior: {
          label: 'Мин.Юст / МВД',
          labelDocs: ': Загранпаспорт',
          labelSelect: 'Выбрать...',
          labelSelected: 'выбрано',
          labelSelectedAll: 'Выбрано все',
          description: 'Помогаем в оформлении документов: Справка о несудимости, Выписка из решения суда, Решении суда',
          details: {root: 'Министерство Юстиций / Внутренних дел'},
          certsLabel: 'Выберите требуемые справки',
          certs: [
            {
              value: 'good_conduct',
              label: 'Справка о несудимости',
            },
            {
              value: 'cert_court_decision',
              label: 'Выписка из решения суда',
            },
            {
              value: 'court_decision',
              label: 'Решение суда'
            }
          ]
        }
      },
    },
    serviceOrdered: {
      legend: 'Заказано',
      comment: 'Комментарий к заказу',
      agreement: 'Даю согласие на обработку моих персональных данных',
      submitBtn: 'Отправить',
      table: {
        th: {
          pos: '#',
          name: 'Наименование',
          details: 'Описание',
          deadline: 'Сроки',
          price: 'Стоимость',
          delete: 'Удалить'
        },
        td: {
          translation: {
            deadline: {
              value: 'дня',
              days: '1-2'
            },
            price: {
              value: '€',
              price: 18
            }
          },
          passport: {
            deadline: {
              value: 'дней',
              days: '30-60'
            },
            price: {
              value: '€',
              price: NaN
            }
          },
          civil_reg: {
            deadline: {
              value: {'1': 'день', '234': 'дня', '056789': 'дней'},
              death: 7,
              birth: 7,
              marriage: 7,
              marriage_ru: 7,
              marriage_uk: 7,
              marriage_md: 7,
              marriage_by: 7,
              marriage_ge: 7,
              marriage_uz: 7,
              marriage_kz: 7,
              marriage_tj: 7,
              divorce: 7,
              fullname: 7,
              family: 7
            },
            price: {
              value: '€',
              death: 120,
              birth: 120,
              marriage: 265,
              marriage_ru: 280,
              marriage_uk: 120,
              marriage_md: 180,
              marriage_by: 250,
              marriage_ge: 300,
              marriage_uz: 330,
              marriage_kz: 330,
              marriage_tj: 330,
              divorce: 120,
              fullname: 120,
              family: 160
            }
          },
          residence: {
            deadline: {
              value: 'дней',
              days: '15-60'
            },
            price: {
              value: '€',
              price: '120-170'
            }
          },
          education: {
            deadline: {
              value: 'дней',
              days: '15-60'
            },
            price: {
              value: '€',
              price: NaN
            }
          },
          min_justice_interior: {
            deadline: {
              value: {'1': 'день', '234': 'дня', '056789': 'дней'},
              good_conduct: '15-60',
              cert_court_decision: '15-60',
              court_decision: '15-60'
            },
            price: {
              value: '€',
              good_conduct: 120,
              cert_court_decision: 120,
              court_decision: 120
            }
          }
        }
      }
    },
    datepicker: {
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль',
        'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      weekdaysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
    },
    message: {
      form_invalid: 'Пожалуйста проверьте и заполните все поля * красным',
      max_file_size: 'Максимальный размер всех файлов 5 Мегабайт',
      allowed_files: 'Можна загружать: JPG, PNG, PDF, TXT, DOC, DOCX',
      wrong_file: 'Следующий файл был пропущен: ',
      wrong_files: 'Следующие файлы были пропущены: ',
      zip_err: 'Произошла ошибка. Попробуйте выбрать другие файлы',
      contacts_wrong: 'Проверьте и заполните все контактные данные',
      no_order_chosen: 'Выберите хотя бы одну услугу',
      choose_an_order: 'Сначала выберите услугу',
      agreement_unaccepted: 'Вы даете соглашение на обработку Ваших персональных данных?!',
      attention: 'Внимание!',
      order_submitted: 'Ваш заказ отправлен. Спасибо, что выбрали VashCenter!',
      order_submit_err: 'Произошла ошибка, Ваш заказ не оправлен.<br>Пожалуйста свяжитесь с нами по телефону: <a href="tel:'
      + CONTACT_TEL.replace(/[^\d]/g, '') + '">' + CONTACT_TEL + '</a>',
      processing: 'Обработка <img src=' + ldots + ' alt="">',

      email: {
        customer: {
          subject: 'Онлайн заказ документов',
          body: '$firstname $lastname,<br><br>Ваш заказ <b>$id</b> принят в работу. В ближайшее время мы свяжемся с Вами для подтверждения деталей.<br><br>Спасибо, что выбрали <a href="'
          + WEBSITE_URL + '" target="_blank">VashCenter</a>!'
        },
        vashcenter: {
          subject: 'Онлайн заказ от $lastname: $order',
          body: {
            creds: '<b>ФИО</b>: $firstname $lastname',
            tel: '<b>Тел</b>: <a href="tel:$phoneHref">$phone</a>',
            email: '<b>Email</b>: <a href="mailto:$email">$email</a>',
            comment: '<b>Комментарий</b>: $comment',
            order: '<b>Заказ</b>:',
            orders: '<b>Заказы</b>:',
            deadline: '<u>Крайний срок</u>: $deadline',
            details: {}
          }
        }
      }
    }
  },
  uk: {
    contact: {
      legend: 'Контактні дані',
      elem: {
        firstname: {
          label: 'Ім\'я',
          placeholder: 'Введіть Ваше Ім\'я'
        },
        lastname: {
          label: 'Прізвище',
          placeholder: 'Введіть Ваше Прізвище'
        },
        phone: {
          label: 'Телефон',
          placeholder: 'Введіть Ваш Телефон'
        },
        email: {
          label: 'E-mail',
          placeholder: 'Введіть Ваш E-mail'
        }
      }
    },
    service: {
      legend: 'Послуги',
      labelOpt: 'Оберіть послугу',
      labelDocs: 'Виберіть документи',
      labelDocsInfoField: {
        empty: 'Вибрати...',
        selectedZero: 'Вибрати знову...',
        selectedOne: '1 файл, Розмір: $1',
        selectedMulti: 'Файлів: $1, Розмір: $2'
      },
      labelDeadline: 'Вкажіть крайній строк',
      labelDescr: 'Опис',
      addOrderBtn: 'Додати замовлення',
      elem: {
        translation: {
          label: 'Переклад',
          labelDocs: ' для перекладу',
          labelDetail: 'Напрямок перекладу',
          description: 'Офіційні переклади, письмові переклади, переклади Міністерства закордонних справ Греції',
          language: [['translateFrom', 'Перекласти з...'],
            ['translateTo', 'Перекласти на...'], ['ru', 'Російська'],
            ['uk', 'Українська'], ['el', 'Грецька'], ['en', 'Англійська'],
            ['de', 'Німецька'], ['fr', 'Французька'], ['it', 'Італійська'],
            ['pt', 'Португальська'], ['az', 'Азербайджанська'],
            ['ar', 'Арабська'], ['am', 'Вірменська'], ['be', 'Білоруська'],
            ['bg', 'Болгарська'], ['hu', 'Угорська'], ['vi', 'В\'єтнамська'],
            ['nl', 'Голландська (Нідерландська)'], ['ka', 'Грузинська'],
            ['da', 'Данська'], ['he', 'Іврит'], ['id', ' Індонезійська'],
            ['kk', 'Казахська'], ['ky', 'Киргизька'], ['zh', 'Китайська'],
            ['ko', 'Корейська'], ['la', 'Латинська'], ['lv', 'Латвійська'],
            ['lt', 'Литовська'], ['mo', 'Молдавська'], ['no', 'Норвезька'],
            ['fa', 'Перська'], ['pl', 'Польська'], ['Ro', 'Румунська'],
            ['sr', 'Сербська'], ['sk', 'Словацька'], ['sl', 'Словенська'],
            ['dr', 'Дарі'], ['tg', 'Таджицька'], ['th', 'Тайська'],
            ['tt', 'Татарська'], ['tr', 'Турецька'], ['tk', 'Туркменська'],
            ['uz', 'Узбецька'], ['fi', 'Фінська'], ['hr', 'Хорватська'],
            ['cs', 'Чеська'], ['sv', 'Шведська'], ['hi', 'Хінді'],
            ['et', 'Естонська'], ['ja', 'Японська']],
          state: ['translateFrom', 'translateTo'],
          details: {root: 'Переклад', translation: 'Переклад з $1 на $2'}
        },
        passport: {
          label: 'Паспорт',
          labelDocs: ': Закордонний паспорт, ІНН, ВНЖ (адія)',
          description: 'Компанія VashCenter надає допомогу в оформленні пакета документів на продовження або новий паспорт. Всі питання продовження терміну дії паспортів, і допомога у виготовленні нових',
          details: {root: 'Закордонний паспорт громадянина України'}
        },
        civil_reg: {
          label: 'РАЦС',
          labelDocs: ': Закордонний паспорт',
          labelSelect: 'Обрати...',
          labelSelected: 'обрано',
          labelSelectedAll: 'Обрано всі',
          description: 'Компанія допомагає в питаннях сімейного права, оформленні пакету документів для шлюбу, возз\'єднання сім\'ї, а також допомагає з оформленням довідок таких як: Довідка про смерть, Довідка про народження, Довідка для оформлення шлюбу, Довідка про розлучення, Довідка про зміну П.І.Б., Довідка про сімейний стан',
          certsLabel: 'Виберіть необхідні довідки',
          details: {root: 'РАЦС'},
          certs: [
            {
              value: 'death',
              label: 'Свідоцтво про смерть',
            },
            {
              value: 'birth',
              label: 'Свідоцтво про народження',
              docs: 'Свідоцтво про народження'
            },
            {
              value: 'marriage',
              label: 'Довідка для оформлення шлюбу',
              docs: 'VISA / ВНЖ, Свідоцтво про народження',
              details: 'Довідка для оформлення шлюбу, країна: $1',
              state: ['marriage']
            },
            {
              value: 'divorce',
              label: 'Свідоцтво про розлучення',
              docs: 'VISA / ВНЖ, Свідоцтво про розлучення'
            },
            {
              value: 'fullname',
              label: 'Свідоцтво про зміну П.І.Б',
              docs: 'Свідоцтво про народження'
            },
            {
              value: 'family',
              label: 'Свідоцтво про сімейний стан'
            }
          ],
          marriageLabel: 'Оберіть країну шлюбу',
          marriage: [['select', 'Обрати...'], ['ru', 'Росія'],
            ['uk', 'Україна'], ['md', 'Молдова'], ['by', 'Білорусія'],
            ['ge', 'Грузія'], ['uz', 'Узбекистан'], ['kz', 'Казахстан'],
            ['tj', 'Таджикістан']],
        },
        residence: {
          label: 'ВНЖ',
          labelDocs: ': Закордонний паспорт, ВНЖ',
          description: 'Подача і оновлення посвідки на проживання всіх категорій, подача на ВНЖ і громадянство згідно нового закону 4251/2014',
          details: {root: 'Вид на жительство'}
        },
        education: {
          label: 'Освіта',
          labelDocs: ': Закордонний паспорт, Атестат (школа)',
          description: 'Підготовка та оформлення пакету документів для вступу до грецьких ВНЗ',
          details: {root: 'Освіта в Греції'}
        },
        min_justice_interior: {
          label: 'Мін.Юст / МВС',
          labelDocs: ': Закордонний паспорт',
          labelSelect: 'Обрати...',
          labelSelected: 'обрано',
          labelSelectedAll: 'Обрано всі',
          description: 'Допомагаємо в оформленні документів: Довідка про несудимість, Виписка з рішення суду, Рішення суду',
          details: {root: 'Міністерство Юстицій / Внутрішніх справ'},
          certsLabel: 'Виберіть необхідні довідки',
          certs: [
            {
              value: 'good_conduct',
              label: 'Довідка про несудимість',
            },
            {
              value: 'cert_court_decision',
              label: 'Виписка з рішення суду',
            },
            {
              value: 'court_decision',
              label: 'Рішення суду'
            }
          ]
        }
      },
    },
    serviceOrdered: {
      legend: 'Замовлено',
      comment: 'Коментарій до замовлення',
      agreement: 'Даю згоду на обробку моїх персональних даних',
      submitBtn: 'Відправити',
      table: {
        th: {
          pos: '#',
          name: 'Найменування',
          details: 'Опис',
          deadline: 'Строки',
          price: 'Вартість',
          delete: 'Видалити'
        },
        td: {
          translation: {
            deadline: {value: 'дня'},
            price: {value: '€'}
          },
          passport: {
            deadline: {value: 'днів'},
            price: {value: '€'}
          },
          civil_reg: {
            deadline: {value: {'1': 'день', '234': 'дні', '056789': 'днів'}},
            price: {value: '€'}
          },
          residence: {
            deadline: {value: 'дней'},
            price: {value: '€'}
          },
          education: {
            deadline: {value: 'днів'},
            price: {value: '€'}
          },
          min_justice_interior: {
            deadline: {value: {'1': 'день', '234': 'дні', '056789': 'днів'}},
            price: {value: '€'}
          }
        }
      }
    },
    datepicker: {
      months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень',
        'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
      weekdaysMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
    },
    message: {
      form_invalid: 'Будь-ласка перевірте і заповніть всі поля * червоним',
      max_file_size: 'Максимальний розмір всіх файлів 5 Мегабайт',
      allowed_files: 'Можна завантажувати: JPG, PNG, PDF, TXT, DOC, DOCX',
      wrong_file: 'Наступний файл пропущено: ',
      wrong_files: 'Наступні файли були пропущені: ',
      zip_err: 'Виникла помилка. Спробуйте вибрати інши файли',
      contacts_wrong: 'Перевірте та заповніть всі контактні дані',
      no_order_chosen: 'Виберіть хоча б одну послугу',
      choose_an_order: 'Спочатку оберіть послугу',
      agreement_unaccepted: 'Ви даєте згоду на обробку Ваших персональних даних?!',
      attention: 'Увага!',
      order_submitted: 'Ваше замовлення відправлено. Дякуємо, що обрали VashCenter!',
      order_submit_err: 'Виникла помилка, Ваше замовлення не відправлено.<br>Будь-ласка зв\'яжіться з нами за телефоном: <a href="tel:'
      + CONTACT_TEL.replace(/[^\d]/g, '') + '">' + CONTACT_TEL + '</a>',
      processing: 'Обробка <img src=' + ldots + ' alt="">',
      email: {
        customer: {
          subject: 'Онлайн замовлення документів',
          body: '$firstname $lastname,<br><br>Ваше замовлення <b>$id</b> прийнято в роботу. Найближчим часом ми зв\'яжемося з Вами для підтвердження деталей.<br><br>Дякуємо що обрали <a href="'
          + WEBSITE_URL + '" target="_blank">VashCenter</a>!'
        }
      }
    }
  },
  en: {
    contact: {
      legend: 'Contacts',
      elem: {
        firstname: {
          label: 'First Name',
          placeholder: 'Type your First Name'
        },
        lastname: {
          label: 'Last Name',
          placeholder: 'Type your Last Name'
        },
        phone: {
          label: 'Telephone',
          placeholder: 'Type your number'
        },
        email: {
          label: 'E-mail',
          placeholder: 'Type your E-mail'
        }
      }
    },
    service: {
      legend: 'Services',
      labelOpt: 'Opt service',
      labelDocs: 'Choose documents',
      labelDocsInfoField: {
        empty: 'Choose...',
        selectedZero: 'Choose again...',
        selectedOne: '1 file, Size: $1',
        selectedMulti: 'Files: $1, Size: $2'
      },
      labelDeadline: 'Deadline',
      labelDescr: 'Description',
      addOrderBtn: 'Add Order',
      elem: {
        translation: {
          label: 'Translation',
          labelDocs: ' for translation',
          labelDetail: 'Translation direction',
          description: 'Official translations, written translations, translations of the Ministry of Foreign Affairs of Greece',
          language: [['translateFrom', 'Translate from...'],
            ['translateTo', 'Translate to...'], ['ru', 'Russian'],
            ['uk', 'Ukrainian'], ['el', 'Greek'], ['en', 'English'],
            ['de', 'German'], ['fr', 'French'], ['it', 'Italian'],
            ['pt', 'Portuguese'], ['az', 'Azerbaijani'], ['ar', 'Arab'],
            ['am', 'Armenian'], ['be', 'Belorussian'], ['bg', 'Bulgarian'],
            ['hu', 'Hungarian'], ['vi', 'Vietnamese'], ['nl', 'Dutch'],
            ['ka', 'Georgian'], ['da', 'Danish'], ['he', 'Hebrew'],
            ['id', 'Indonesian'], ['kk', 'Kazakh'], ['ky', 'Kyrgyz'],
            ['zh', 'Chinese'], ['ko', 'Korean'], ['la', 'Latin'],
            ['lv', 'Latvian'], ['lt', 'Lithuanian'], ['mo', 'Moldavian'],
            ['no', 'Norwegian'], ['fa', 'Persian'], ['pl', 'Polish'],
            ['ro', 'Romanian'], ['sr', 'Serbian'], ['sk', 'Slovak'],
            ['sl', 'Slovenian'], ['dr', 'Dari'], ['tg', 'Tajik'],
            ['th', 'Thai'], ['tt', 'Tatar'], ['tr', 'Turkish'],
            ['tk', 'Turkmen'], ['uz', 'Uzbek'], ['fi', 'Finnish'],
            ['hr', 'Croatian'], ['cs', 'Czech'], ['sv', 'Swedish'],
            ['hi', 'Hindi'], ['et', 'Estonian'], ['ja', 'Japanese']],
          state: ['translateFrom', 'translateTo'],
          details: {
            root: 'Translation',
            translation: 'Translate from $1 into $2'
          }
        },
        passport: {
          label: 'Passport',
          labelDocs: ': Passport, VAT, Residence document (Adia Diamonis)',
          description: 'VashCenter assists in passport issue or renewal. All issues of extending the validity of passports, and assistance in the production of new',
          details: {root: 'Passport'}
        },
        civil_reg: {
          label: 'Civil Registration',
          labelDocs: ': Passport',
          labelSelect: 'Choose...',
          labelSelected: 'selected',
          labelSelectedAll: 'All selected',
          description: 'The company helps with family law, gathering a package of documents for marriage, family reunification, and also helps with the preparation of certificates such as: Death certificate, Birth certificate, Certificate for marriage registration, Divorce certificate, Certificate of full name change, Certificate of marital status',
          certsLabel: 'Choose necessary certificates',
          details: {root: 'Civil Registration'},
          certs: [
            {
              value: 'death',
              label: 'Death certificate',
            },
            {
              value: 'birth',
              label: 'Birth certificate',
              docs: 'Birth document'
            },
            {
              value: 'marriage',
              label: 'Certificate for marriage registration',
              docs: 'VISA / Residence document, Birth document',
              details: 'Certificate for marriage registration in: $1',
              state: ['marriage']
            },
            {
              value: 'divorce',
              label: 'Divorce certificate',
              docs: 'VISA / Residence document, Divorce document'
            },
            {
              value: 'fullname',
              label: 'Certificate of full name change',
              docs: 'Birth document'
            },
            {
              value: 'family',
              label: 'Certificate of marital status'
            }
          ],
          marriageLabel: 'Choose marriage country',
          marriage: [['select', 'Choose...'], ['ru', 'Russia'],
            ['uk', 'Ukraine'], ['md', 'Moldova'], ['by', 'Belarus'],
            ['ge', 'Georgia'], ['uz', 'Uzbekistan'], ['kz', 'Kazakhstan'],
            ['tj', 'Tajikistan']],
        },
        residence: {
          label: 'Residence',
          labelDocs: ': Passport, Residence document',
          description: 'Appealing or renewal of residence permit for all categories, appealing for residence permit and citizenship under the new law 4251/2014',
          details: {root: 'Residence permit'}
        },
        education: {
          label: 'Education',
          labelDocs: ': Passport, Diploma (school)',
          description: 'Documents preparation for admission to Greek universities',
          details: {root: 'Education in Greece'}
        },
        min_justice_interior: {
          label: 'Ministry of Justice / Interior',
          labelDocs: ': Passport',
          labelSelect: 'Choose...',
          labelSelected: 'selected',
          description: 'We aid in issuing certificates: Good conduct certificate, Court decision certificate, Court decision',
          details: {root: 'Ministry of Justice / Interior'},
          certsLabel: 'Choose necessary certificates',
          certs: [
            {
              value: 'good_conduct',
              label: 'Good conduct certificate',
            },
            {
              value: 'cert_court_decision',
              label: 'Court decision certificate',
            },
            {
              value: 'court_decision',
              label: 'Court decision'
            }
          ]
        }
      },
    },
    serviceOrdered: {
      legend: 'Ordered',
      comment: 'Comment',
      agreement: 'I agree for processing my sensitive personal data',
      submitBtn: 'Submit',
      table: {
        th: {
          pos: '#',
          name: 'Name',
          details: 'Description',
          deadline: 'Time',
          price: 'Price',
          delete: 'Remove'
        },
        td: {
          translation: {
            deadline: {value: 'days'},
            price: {value: '€'}
          },
          passport: {
            deadline: {value: 'days'},
            price: {value: '€'}
          },
          civil_reg: {
            deadline: {value: {'1': 'day', '023456789': 'days'}},
            price: {value: '€'}
          },
          residence: {
            deadline: {value: 'days'},
            price: {value: '€'}
          },
          education: {
            deadline: {value: 'days'},
            price: {value: '€'}
          },
          min_justice_interior: {
            deadline: {value: {'1': 'day', '023456789': 'days'}},
            price: {value: '€'}
          }
        }
      }
    },
    datepicker: {
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July',
        'August', 'September', 'October', 'November', 'December'],
      weekdaysMin: ['Su', 'Mo', 'Tu', 'Wd', 'Th', 'Fr', 'Sa']
    },
    message: {
      form_invalid: 'Please check and fill all the fields in red',
      max_file_size: 'Max file size up to 5 Megabytes',
      allowed_files: 'Allowed to upload: JPG, PNG, PDF, TXT, DOC, DOCX',
      wrong_file: 'The following file was skipped: ',
      wrong_files: 'The following files were skipped: ',
      zip_err: 'An error occurred. Please try to choose other files',
      contacts_wrong: 'Check and fill in all the contact details',
      no_order_chosen: 'You should choose one of services',
      choose_an_order: 'Firstly choose an order',
      agreement_unaccepted: 'Do you agree with processing your sensitive personal data?!',
      attention: 'Attention!',
      order_submitted: 'Your order was submitted. Thank you for choosing VashCenter.',
      order_submit_err: 'An error occurred. Your order wasn\'t submitted.<br>Please phone us: <a href="tel:'
      + CONTACT_TEL.replace(/[^\d]/g, '') + '">' + CONTACT_TEL + '</a>',
      processing: 'Processing <img src=' + ldots + ' alt="">',
      email: {
        customer: {
          subject: 'Online docs order',
          body: '$firstname $lastname,<br><br>You order <b>$id</b> accepted. We\'ll contact you soon to confirm details.<br><br>Thank you for choosing <a href="'
          + WEBSITE_URL + '" target="_blank">VashCenter</a>!'
        }
      }
    }
  }
};

for (let code of ['ru', 'uk', 'en']) {
  lang[code].service.elem.civil_reg.details = Object.assign({},
      lang[code].service.elem.civil_reg.details,
      helpers.genDetails(lang[code].service.elem.civil_reg.certs));
  lang[code].service.elem.min_justice_interior.details = Object.assign({},
      lang[code].service.elem.min_justice_interior.details,
      helpers.genDetails(lang[code].service.elem.min_justice_interior.certs));
}

for (let order of Object.keys(lang.ru.service.elem)) {
  lang.ru.message.email.vashcenter.body.details[order] = lang.ru.service.elem[order].details;
}

let orders = lang.ru.serviceOrdered.table.td;

for (let name in orders) {
  let order = orders[name];

  for (let target of ['deadline', 'price']) {
    for (let key in order[target]) {
      if (key !== 'value') {
        lang.uk.serviceOrdered.table.td[name][target][key] = order[target][key];
        lang.en.serviceOrdered.table.td[name][target][key] = order[target][key];
      }
    }
  }
}

lang.el = lang.en;

export default lang;


// WEBPACK FOOTER //
// ./src/app/lang.js